var _circle, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddVoiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#E65C6C",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 66H54M60 43.5V46.5C60 53.1 54.6 58.5 48 58.5M48 58.5C41.4 58.5 36 53.1 36 46.5V43.5M48 58.5V66",
    stroke: "url(#paint0_linear_542_13486)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0001 54.0001C47.0101 53.9977 46.0307 53.7965 45.12 53.4084C44.2093 53.0203 43.3858 52.4532 42.6985 51.7407C41.2916 50.3216 40.5015 48.4046 40.5001 46.4063V36.0001C40.4962 35.0141 40.6876 34.0371 41.0631 33.1254C41.4387 32.2137 41.991 31.3854 42.6882 30.6882C43.3854 29.991 44.2137 29.4387 45.1254 29.0631C46.0371 28.6876 47.0141 28.4962 48.0001 28.5001C52.2057 28.5001 55.5001 31.7944 55.5001 36.0001V46.4063C55.5001 50.5932 52.1354 54.0001 48.0001 54.0001Z",
    fill: "url(#paint1_linear_542_13486)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_542_13486",
    x1: 36,
    y1: 54.75,
    x2: 60,
    y2: 54.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65CA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_542_13486",
    x1: 40.5,
    y1: 41.25,
    x2: 55.5001,
    y2: 41.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65CA7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddVoiceIcon);
export default __webpack_public_path__ + "static/media/add-voice-icon.fb291826fc3106ea1e5b445c35df579c.svg";
export { ForwardRef as ReactComponent };